var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-chart",style:({width: _vm.config.chartWidth+'px',height:_vm.config.chartHeight+'px'})},[_c('div',{staticClass:"map-chart-wrapper"},[(_vm.borderImgUrl)?_c('img',{staticClass:"map-chart-border",style:({
        display:'inline-block',
        width:'100%',
        height: '100%'
      }),attrs:{"src":_vm.borderImgUrl,"alt":""}}):_vm._e(),_c('div',{staticClass:"map-chart-title",style:({
      width:'100%',
      textAlign: _vm.style.titleStyle.align,
      fontSize: _vm.style.titleStyle.fontSize + 'px',
      color: _vm.style.titleStyle.color,})},[_vm._v(" "+_vm._s(_vm.config.chartTitle)+" "),(_vm.config.chartViewData.showIndicator)?_c('el-tooltip',{staticClass:"item",attrs:{"open-delay":500,"effect":"dark","placement":"top"}},[_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.indicatorDescription)},slot:"content"}),_c('i',{staticClass:"el-icon-question"})]):_vm._e()],1)]),_c('div',{ref:"mapChart",staticClass:"map-chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }